import gql from 'graphql-tag';

const OTA_FIRMWARE_VERSION_LIST = gql`
  query Query {
    getOTAFirmwareList {
      code
      data {
        version
        OTASubmittedBy
        status
        OTASubmittedOn
        deviceType
        hardwareVersion
        OTASubmittedByName
        url
        crc
        approvedBy
        approvedOn
        approvedByName
      }
    }
  }
`;

export default OTA_FIRMWARE_VERSION_LIST;
